import { UAParser } from 'ua-parser-js';

const API_BASE = 'https://carsholic.vercel.app';

export function trackVisit() {
  const accessToken = localStorage.getItem('access_token');
  const { browser, os, device } = new UAParser(navigator.userAgent).getResult();

  const payload = {
    browser: browser.name ? `${browser.name} ${browser.version || ''}`.trim() : null,
    os: os.name ? `${os.name} ${os.version || ''}`.trim() : null,
    device_type: device.type || 'desktop',
  };

  fetch(`${API_BASE}/api/visit/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    },
    body: JSON.stringify(payload),
  }).catch((error) => {
    console.warn('Visit tracking failed:', error);
  });
}
